<template>
  <family-page-wrapper>
    <caller-active-hours />
  </family-page-wrapper>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const CallerActiveHours = defineAsyncComponent(() => import('../Operator/FamilyMember/CallerActiveHours.vue') as any);
</script>
